import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Analytics from '../components/Template/Analytics';
import Navigation from '../components/Template/Navigation';
import SideBar from '../components/Template/SideBar';
import ScrollToTop from '../components/Template/ScrollToTop';
import { buildAbsoluteUrl, DEFAULT_ROBOTS } from '../data/seo';

const getCanonicalPath = (canonicalPath) => {
  if (canonicalPath) {
    return canonicalPath;
  }

  if (typeof window !== 'undefined' && window.location?.pathname) {
    return window.location.pathname;
  }

  return '/';
};

const Main = (props) => (
  <HelmetProvider>
    <Analytics />
    <ScrollToTop />
    <Helmet
      titleTemplate="%s | Timothy Demonbreun"
      defaultTitle="Timothy Demonbreun"
      defer={false}
    >
      {props.title && <title>{props.title}</title>}
      <meta name="description" content={props.description} />
      <meta name="robots" content={props.robots} />
      <meta name="theme-color" content="#ffffff" />
      <meta name="color-scheme" content="light" />
      <meta property="og:title" content={props.title ? `${props.title} | Timothy Demonbreun` : 'Timothy Demonbreun'} />
      <meta property="og:description" content={props.description} />
      <meta property="og:type" content={props.ogType} />
      <meta property="og:url" content={buildAbsoluteUrl(getCanonicalPath(props.canonicalPath))} />
      <meta property="og:image" content={buildAbsoluteUrl(props.image || '/images/me.jpg')} />
      <meta property="og:image:alt" content="Timothy Demonbreun" />
      <meta name="twitter:card" content={props.image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={props.title ? `${props.title} | Timothy Demonbreun` : 'Timothy Demonbreun'} />
      <meta name="twitter:description" content={props.description} />
      <meta name="twitter:image" content={buildAbsoluteUrl(props.image || '/images/me.jpg')} />
      <link rel="canonical" href={buildAbsoluteUrl(getCanonicalPath(props.canonicalPath))} />
    </Helmet>
    <div id="wrapper">
      <Navigation />
      <div id="main">{props.children}</div>
      {props.fullPage ? null : <SideBar />}
    </div>
  </HelmetProvider>
);

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
  canonicalPath: PropTypes.string,
  image: PropTypes.string,
  ogType: PropTypes.string,
  robots: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

Main.defaultProps = {
  children: null,
  fullPage: false,
  canonicalPath: null,
  image: '/images/me.jpg',
  ogType: 'website',
  robots: DEFAULT_ROBOTS,
  title: null,
  description: "Timothy Demonbreun's personal website.",
};

export default Main;
